/* eslint-disable no-underscore-dangle */
const TILE_LAYER_TYPES = ['xyz', 'fulcrum', 'mbtiles', 'wms'];

export default class LayerManager {
  UtfGrid;
  _map;
  _layers;
  _layersOrdered;
  private _dataOverlayMapKey?: string;
  private _dataOverlayMap: any;
  constructor(map) {
    // TODO: Can we get away with not lazy-loading this?
    //       We don't know if the `google.maps` object is ready yet.
    this.UtfGrid = import('./utf-grid');
    this._map = map;
    this._layers = {};

    this.types.forEach((type) => {
      this._layers[type] = {};
    });
  }

  // eslint-disable-next-line class-methods-use-this
  get types() {
    return ['xyz', 'mbtiles', 'geojson', 'data', 'fulcrum', 'wms'];
  }

  set layerOrder(layersOrdered) {
    this._layersOrdered = layersOrdered;
    this._orderLayers();
  }

  addLayers(layerObjects) {
    Object.keys(layerObjects).forEach((type) => {
      const layerTypeObject = layerObjects[type];

      Object.keys(layerTypeObject).forEach((key) => {
        this._addLayer(key, type, layerTypeObject[key]);
      });
    });
  }

  _addLayer(key, type, layerOrLayers) {
    // eslint-disable-next-line no-prototype-builtins
    if (!this._layers[type].hasOwnProperty(key)) {
      this._layers[type][key] = [];
    }

    let layers = layerOrLayers;

    if (!Array.isArray(layerOrLayers)) {
      layers = [layers];
    }

    if (TILE_LAYER_TYPES.includes(type)) {
      this.hideDataLayers();
    }

    if (type === 'geojson') {
      layers.forEach((layer) => {
        const features = this._map.data.addGeoJson(layer);
        this._layers[type][key].push(features);
      });
    } else {
      layers.forEach(async (layer) => {
        const { default: UtfGrid } = await this.UtfGrid;
        // eslint-disable-next-line no-param-reassign
        layer._key = key;
        if (layer instanceof UtfGrid) {
          layer.setMap(this._map);
        } else {
          if (type === 'data') {
            this._dataOverlayMapKey = key;
            this._dataOverlayMap = layer;
          }

          this._map.overlayMapTypes.push(layer);
        }

        this._layers[type][key].push(layer);
      });
    }

    if (TILE_LAYER_TYPES.includes(type)) {
      this.showDataLayers();
    }
  }

  _orderLayers() {
    this._orderXyzLayers();
  }

  _orderXyzLayers() {
    const { overlayMapTypes } = this._map;

    if (overlayMapTypes.getLength() > 1) {
      // Hide the record data layer
      this.hideDataLayers();

      overlayMapTypes.clear();
      // Add all ordered layers onto the map, if they are valid
      this._layersOrdered.forEach((key) => {
        const layerDef = JSON.parse(key);

        if (TILE_LAYER_TYPES.includes(layerDef.type)) {
          const layerList = this._layers[layerDef.type][key];

          if (layerList) {
            layerList.forEach((layer) => {
              // @ts-ignore
              if (layer instanceof google.maps.ImageMapType) {
                overlayMapTypes.push(layer);
              }
            });
          }
        }
      });
      // Add the record data layer back. This way it's always on top
      this.showDataLayers();
    }
  }

  removeLayers(layerObjects) {
    Object.keys(layerObjects).forEach((type) => {
      Object.keys(layerObjects[type]).forEach((key) => {
        this._layers[type][key].forEach(async (layer) => {
          const { default: UtfGrid } = await this.UtfGrid;
          if (type === 'geojson') {
            layer.forEach((feature) => this._map.data.remove(feature));
          } else if (layer instanceof UtfGrid) {
            layer.setMap(null);
          } else {
            this.removeOverlayMapForKey(key);
          }
        });

        delete this._layers[type][key];
      });
    });
  }

  removeOverlayMapForKey(key) {
    let indexToRemove = null;

    this._map.overlayMapTypes.forEach((overlayMap, index) => {
      if (overlayMap._key === key) {
        indexToRemove = index;
      }
    });

    if (indexToRemove != null) {
      this._map.overlayMapTypes.removeAt(indexToRemove);
    }
  }

  hideDataLayers() {
    if (this._dataOverlayMapKey) {
      this.removeOverlayMapForKey(this._dataOverlayMapKey);
    }
  }

  showDataLayers() {
    if (this._dataOverlayMap) {
      this._map.overlayMapTypes.push(this._dataOverlayMap);
    }
  }
}
